import { useRef } from 'react';
import { Bell, Info } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import {
  useBreakpoint,
  useUserSettings,
  useUserSettingsUpdate,
} from 'src/hooks';
import { Button } from 'src/v2/commonComponents/Button';
import { SettingKeys, ToggleSetting } from 'src/types/settings';
import { FadeTransition } from 'src/animations/FadeTransition';
import styles from './NotifyMeButton.module.scss';
import { SpanWithHoverTooltip } from 'src/v2/commonComponents/SpanWithHoverTooltip';

interface NotifyMeButtonProps {
  isThinking?: boolean;
}

const NOTIFY_ME_HOVER_TOOLTIP_ID = 'notify-me-tooltip';

export const NotifyMeButton = ({ isThinking = false }: NotifyMeButtonProps) => {
  const buttonRef = useRef<HTMLDivElement | null>(null);

  const { isDesktopAndUp } = useBreakpoint();
  const { setting } = useUserSettings<ToggleSetting>(
    SettingKeys.DEEP_RESEARCH_EMAIL,
  );

  const { updateUserSetting, isUpdateIsLoading } = useUserSettingsUpdate();

  const handleNotifyClick = () => {
    updateUserSetting({
      value: true,
      settingKey: SettingKeys.DEEP_RESEARCH_EMAIL,
    });
  };

  return (
    <FadeTransition inProp={!setting?.value && isThinking} nodeRef={buttonRef}>
      <div className={styles.root} ref={buttonRef}>
        <Button
          color="link"
          onClick={handleNotifyClick}
          disabled={isUpdateIsLoading}
        >
          <Bell size={SVG_SIZE_M} />
          {isDesktopAndUp && <span>Notify me</span>}
        </Button>

        {isDesktopAndUp && (
          <SpanWithHoverTooltip
            className={styles.infoIcon}
            tooltipId={NOTIFY_ME_HOVER_TOOLTIP_ID}
            tooltipContent="Send email once Deep Research results are available."
            tooltipPlace="top"
          >
            <Info size={SVG_SIZE_M} />
          </SpanWithHoverTooltip>
        )}
      </div>
    </FadeTransition>
  );
};
